/* DetailPanel.js */

import React, { useState } from "react";
import { ViewType } from "../../../Enums.js";
import UserFunctionPanel from "./UserFunctionPanel.js";
import FormResponsesPanel from "./FormResponsesPanel.js";
import MetaPanel from "./MetaPanel.js";
import AIPanel from "./AIPanel.js";

import "./DetailPanel.css";

export default function DetailPanelView({
  fields,
  row,
  logs,
  containerWidth,
  offsetLeft,
  viewType,
  projectCode,
  onCellUpdate,
  onFileUpdate,
  onReviewerChange,
  onResetPassword,
  onSendPasswordResetEmail,
  onAdminise,
  theme,
  locale,
  timeZone,
  dateFormat,
  currency,
}) {
  const [leftWidth, setLeftWidth] = useState(60); // percent

  const handleMouseDown = (e) => {
    const startX = e.clientX;
    const startWidth = leftWidth;

    const handleMouseMove = (e) => {
      const delta = e.clientX - startX;
      const container = document
        .querySelector(".detail-panel-split")
        ?.getBoundingClientRect();
      const containerW = container?.width || 1;
      const newLeft = ((startWidth / 100) * containerW + delta) / containerW;
      setLeftWidth(Math.max(20, Math.min(80, newLeft * 100)));
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const renderEnv = {
    projectCode,
    theme,
    locale,
    timeZone,
    dateFormat,
    currency,
    handlers: { onCellUpdate, onFileUpdate, onReviewerChange },
  };

  let content = null;

  switch (viewType) {
    case ViewType.USERS:
      content = (
        <div className="single-panel">
          <UserFunctionPanel
            user={row}
            logs={logs}
            onResetPassword={onResetPassword}
            onSendPasswordResetEmail={onSendPasswordResetEmail}
            onAdminise={onAdminise}
          />
        </div>
      );
      break;

    case ViewType.SUBMISSIONS:
    default:
      content = (
        <div className="card-columns-with-gap">
          {/* LEFT: column itself scrolls (single scroller) */}
          <div
            className="resizable-left panel-card"
            style={{ flexBasis: `${leftWidth}%` }}
          >
            <div className="data-card-header">Form Responses</div>
            <div className="panel-body-left">
              <FormResponsesPanel fields={fields} row={row} renderEnv={renderEnv} />
            </div>
          </div>

          {/* RESIZER */}
          <div className="resizer" onMouseDown={handleMouseDown} />

          {/* RIGHT: inner sections have their own scrollers */}
          <div
            className="resizable-right panel-card"
            style={{ flexBasis: `${100 - leftWidth}%` }}
          >
            <div className="meta-card-content meta-card-content--cap">
              <div className="meta-card-header">Meta data</div>
              <div className="panel-scroll">
                <MetaPanel fields={fields} row={row} renderEnv={renderEnv} />
              </div>
            </div>

            <div className="meta-card-content meta-card-content--grow">
              <div className="meta-card-header">AI Feedback</div>
              <div className="panel-scroll">
                <AIPanel row={row} view={{ fields }} />
              </div>
            </div>
          </div>
        </div>
      );
      break;
  }

  return (
    <div className="detail-panel-wrapper">
      <div
        className="detail-panel-fixed-container"
        style={{ left: offsetLeft, width: containerWidth }}
      >
        <div className="detail-panel-split">{content}</div>
      </div>
    </div>
  );
}
